export default __webpack_public_path__ + "static/media/2395.d31023aa.png";